import { render, staticRenderFns } from "./traceAbility.vue?vue&type=template&id=15752136&scoped=true"
import script from "./traceAbility.vue?vue&type=script&lang=js"
export * from "./traceAbility.vue?vue&type=script&lang=js"
import style0 from "./traceAbility.vue?vue&type=style&index=0&id=15752136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15752136",
  null
  
)

export default component.exports